__turbopack_context__.v({
  "isTabActive": "tabs-module-scss-module__h3eTlq__isTabActive",
  "isTabDisabled": "tabs-module-scss-module__h3eTlq__isTabDisabled",
  "tab": "tabs-module-scss-module__h3eTlq__tab",
  "tabCountLabel": "tabs-module-scss-module__h3eTlq__tabCountLabel",
  "tableTabs": "tabs-module-scss-module__h3eTlq__tableTabs",
  "tabsFooter": "tabs-module-scss-module__h3eTlq__tabsFooter",
});
